import {
    RESET_PASSWORD_FORM_CHANGE
} from '../../constants';
export const resetPasswordFormChange = (event)=>{
    return {
        type: RESET_PASSWORD_FORM_CHANGE,
        payload:event
    };
};
